





















import axios from 'axios'
import {Component} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import AuthLayout from '@/components/auth/Layout.vue'
import { apiV1UsersPasswordsPath } from '@/rails/routes'

@Component({
  components: {
    AuthLayout
  }
})
export default class PasswordsIndex extends VueBase {
  email = ''

  mounted(): void {
  }

  async send(): Promise<void> {
    try {
      await axios.post(apiV1UsersPasswordsPath(), {
        email: this.email
      })
      this.showMessage('パスワード再設定メールを送信しました。');
    } catch (e) {
      this.showError('パスワード再設定メールが送信できませんでした。メールアドレスを確認してください。')
    }
  }
}
